import * as React from 'react';

import FilePowerpoint32 from './FilePowerpoint32';

export const filePowerpoint32 = () => <FilePowerpoint32 />;

export default {
    title: 'Icon|Content|FilePowerpoint32',
    component: FilePowerpoint32,
    parameters: {
        notes: "`import FilePowerpoint32 from 'box-ui-elements/es/icon/content/FilePowerpoint32';`",
    },
};
